<template>
  <div>
    <index-header></index-header>
    <div class="_wrapper _wrapper_login">
      <div class="login_form">
        <h2>{{sysName}}查询</h2>
        <a-form :form="form">
          <a-form-item label="预报名号" :help="`※ 如忘记预报名号，请联系${departmentName}！`" style="padding-bottom: 15px;" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
            <a-input size="large" placeholder="请输入预报名号" v-decorator="['teacherSignupId', {
              rules: [{
                required: true,
                message: '报名号不能为空'
              }]
            }]"/>
          </a-form-item>

          <a-form-item :label="studentTypeName+'身份证号'" style="padding-bottom: 15px;" :labelCol="formItemLayout.labelCol" :wrapperCol="formItemLayout.wrapperCol" :required="true">
            <a-input size="large" placeholder="请输入身份证号" v-decorator="['idCard', {
              validateTrigger: 'blur',
              rules: [{
                required: true,
                message: '身份证号不能为空'
              },{
                pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
                message: '身份证号格式错误'
              }]
            }]"/>
          </a-form-item>

          <a-form-item :wrapper-col="formItemLayout.submitWrapperCol" style="padding-top: 10px;">
            <a class="sx-btn sx-btn-min sx-btn-blue" href="javascript:void(0)" @click="handleSubmit">查询</a>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexHeader from "./components/IndexHeader";
  import PageLogin from './mixins/page_login';
  import config from "../../../config";

  const formItemLayout = {
    labelCol: { span: 7 },
    wrapperCol: { span: 12 },
    submitWrapperCol: { span: 12, offset: 7 }
  };

  import IndexCommon from './mixins/index_common';

  export default {
    mixins: [IndexCommon, PageLogin],
    components: { IndexHeader },
    data() {
      return {
        form: this.$form.createForm(this),
        formItemLayout
      };
    },
    created() {
    },
    computed: {
      departmentName() {
        return config.web.departmentName
      }
    },
    methods: {
      handleSubmit() {
        this.form.validateFields(err => {
          if(err) return;

          let formVal = this.form.getFieldsValue();
          console.log("-> formVal", formVal);
          this.ajaxSearchSignupApply(formVal);
        });
      }
    }
  };
</script>

<style lang="stylus" scoped>
  ._wrapper_login {
    padding 120px 0
    .login_form {
      width 700px
      height 400px
      border 1px solid #E5E5E5
      border-radius 16px
      margin 0 auto
      h2 {
        padding 40px 0 20px
        text-align center
        color #175375
        font-size 28px
      }
    }
  }
</style>
